<template>
  <!-- Header -->
  <header class="mb-8">
    <div
      class="flex justify-between items-center px-2.5 pb-5 border-b border-gray-300"
    >
      <h1 class="text-3xl font-bold">Compliance Information Assessment Tool</h1>
      <div class="flex gap-2">
        <div class="flex items-center gap-4">
          <div @click="refreshData" class="flex-grow bg-white">
            <select
              id="client-filter"
              class="border border-gray-300 bg-white px-4 py-2 rounded-md outline-none focus:ring-2 focus:ring-primary truncate max-w-[16rem] overflow-hidden text-ellipsis"
              v-model="selectedCompany"
              @change="emitCompany"
              @click.stop="refreshData"
            >
              <option value="all"></option>
              <option
                v-for="company in enterprises"
                :value="String(company._id)"
                :key="company._id"
              >
                {{
                  company.NomeEmpresa.length > 30
                    ? company.NomeEmpresa.substring(0, 15) + '...'
                    : company.NomeEmpresa
                }}
              </option>
            </select>
          </div>

          <div class="flex-grow bg-white">
            <button
              class="px-6 py-2 border border-gray-300 rounded-md text-gray-800 hover:bg-gray-200"
            >
              Exportar Relatório
            </button>
            <button
              @click="logout"
              class="px-6 py-2 border border-gray-300 rounded-md text-red-600 hover:bg-gray-200"
            >
              Sair
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { getControllersCount } from '@/services/security-controls/api.controllers'
import { getEnterprises } from '@/services/company/api.enterprise'

export default {
  name: 'HeaderComponent',
  data() {
    return {
      enterprises: [],
      controllersCount: 0,
      selectedCompany: localStorage.getItem('selectedCompany') || 'all',
    }
  },
  computed: {
    filteredCompanies() {
      if (this.selectedCompany === 'all') {
        return this.enterprises
      }
      return this.enterprises.filter((e) => e._id === this.selectedCompany)
    },
  },
  created() {
    this.loadEnterprises()
    this.loadControllersCount()
  },

  watch: {
    selectedCompany(newVal) {
      localStorage.setItem('selectedCompany', newVal)
    },
  },

  methods: {
    async loadControllersCount() {
      try {
        const response = await getControllersCount()
        this.controllersCount = response.count
        this.$emit('update-controllers-count', this.controllersCount)
      } catch (error) {
        console.error('Erro ao buscar a contagem de controles:', error)
      }
    },
    async loadEnterprises() {
      try {
        const response = await getEnterprises()
        // console.log('Empresas:', response)
        this.enterprises = response
        this.emitCompany()
      } catch (error) {
        console.error('Erro ao buscar empresas:', error)
      }
    },

    logout() {
      localStorage.removeItem('Name')
      localStorage.removeItem('userId')
      localStorage.removeItem('role')
      localStorage.removeItem('enterprise')
      localStorage.removeItem('selectedCompany')
      localStorage.removeItem('Token')
      this.$router.push('/')
    },

    emitCompany() {
      const selected = this.enterprises.find(
        (e) => e._id === this.selectedCompany
      )
      if (selected) {
        this.$emit('company-selected', selected)
      } else {
        console.warn(
          'Nenhuma empresa encontrada para o ID:',
          this.selectedCompany
        )
      }
    },

    refreshData() {
      this.loadEnterprises()
      this.loadControllersCount()
    },
  },
}
</script>
